import styled from 'styled-components'

export const Banner = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  width: 100%;
  padding: 16px;
  border: 1px solid #ffeaa3;
  border-radius: 8px;
  background: #fff9e3;
  margin-bottom: 24px;
`

export const BannerIcon = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  line-height: 24px;
  color: #d48806;

  svg {
    width: 14px;
    height: 14px;
    font-size: 14px;
  }
`

export const BannerContent = styled.div`
  flex: 1;
  min-width: 0;
`

export const BannerTitle = styled.p`
  margin: 0;
  color: #363636;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  word-break: break-word;
`

export const BannerBody = styled.p`
  margin: 0;
  color: #363636;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  word-break: break-word;
`

export const DownloadButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #0085ff;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  white-space: nowrap;
  cursor: pointer;
  flex-shrink: 0;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  svg {
    font-size: 14px;
    width: 16px;
    height: 16px;
  }
`
